//REGISTER
export const POST_LOGIN_TOKEN = "/login"
export const LOG_OUT = "/logout"
export const RESET_PASSWORD = '/reset'
export const RESET_CONFIRM = '/account-confirm'
export const VALIDA_TOKEN = '/account-valida-token'
//HOME
export const GET_DATA_HOME = 'get-data'

//SALES
export const SALES_RESOURCE = 'sales'
//SELLERS
export const SELLERS_RESOURCE = 'sellers'
//CATEGORIES
export const CATEGORIES_RESOURCE = 'categories'
//DEPARTMENTS
export const DEPARTMENTS_RESOURCE = 'departments'
//PRODUCTS
export const PRODUCTS_RESOURCE = 'catalogs/products'
export const CLIENTS_RESOURCE = 'catalogs/clients'

//CATALOGS
export const SUPER_DEPARTMENTS_RESOURCE = 'catalogs/sueper-departaments'